import React from 'react';

import cn from 'classnames';

import { Skeleton } from '@shared/ui';

import cls from './LoadingTeamSkeleton.module.css';

interface LoadingTeamProps {
    classes?: string;
}

export const LoadingTeamSkeleton = ({ classes }: LoadingTeamProps) => (
    <div className={cn(cls.LoadingTeam, [classes])}>
        <header className={cls.header}>
            <Skeleton border="2px" width="103px" height="20px" />
            <Skeleton border="2px" width="68px" height="16px" />
        </header>
        <ul className={cls.list}>
            <li>
                <Skeleton border="5px" width="100%" height="138px" />
            </li>
            <li>
                <Skeleton border="5px" width="100%" height="138px" />
            </li>
            <li>
                <Skeleton border="5px" width="100%" height="138px" />
            </li>
            <li>
                <Skeleton border="5px" width="100%" height="138px" />
            </li>
            <li>
                <Skeleton border="5px" width="100%" height="138px" />
            </li>
        </ul>
    </div>
);
